/* ==========================================================================
   HART · Early access sign-up.
   Works on top of a real Shopify sign-up form ({% form 'customer' %}): with no script, the form still posts and
   Shopify still saves the email. With script, it checks each field in place, sends the form without leaving the
   page, and shows "You're on the list" only once Shopify has answered that the sign-up was saved.

   Two ways to save:
     email     Shopify's own sign-up form. Saves the email as a customer who agreed to email marketing, with the
               tags in the form. No keys of any kind in the browser.
     endpoint  A server of HART's (normally a Shopify app proxy path such as /apps/hart/early-access) that saves
               email and text-message consent with the Admin API. Only this mode shows the text-message choice.
   ========================================================================== */
(function () {
  'use strict';
  var D = document, W = window;
  var EMAIL_RE = /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/;
  var DRAFT_KEY = 'hart.ea.draft';
  var TIMEOUT = 15000;

  /* Mobile numbers by country: national digits allowed after the country code. strip0: drop a leading trunk 0. */
  var PHONE = {
    US: { dial: '1', test: /^[2-9]\d{2}[2-9]\d{6}$/ },
    CA: { dial: '1', test: /^[2-9]\d{2}[2-9]\d{6}$/ },
    GB: { dial: '44', strip0: true, test: /^7\d{9}$/ },
    DK: { dial: '45', test: /^\d{8}$/ },
    FI: { dial: '358', strip0: true, test: /^\d{6,11}$/ },
    IT: { dial: '39', test: /^3\d{8,10}$/ },
    LU: { dial: '352', test: /^\d{6,11}$/ },
    PL: { dial: '48', test: /^\d{9}$/ },
    PT: { dial: '351', test: /^9\d{8}$/ },
    SE: { dial: '46', strip0: true, test: /^7\d{7,8}$/ }
  };

  function $(s, r) { return (r || D).querySelector(s); }
  function store(kind) { try { return W[kind]; } catch (e) { return null; } }
  function readDraft() { var s = store('sessionStorage'); if (!s) return null; try { return JSON.parse(s.getItem(DRAFT_KEY) || 'null'); } catch (e) { return null; } }
  function writeDraft(d) { var s = store('sessionStorage'); if (!s) return; try { s.setItem(DRAFT_KEY, JSON.stringify(d)); } catch (e) {} }
  function clearDraft() { var s = store('sessionStorage'); if (!s) return; try { s.removeItem(DRAFT_KEY); } catch (e) {} }

  /* Turns what someone typed into an international number, or tells them what to fix. */
  function parsePhone(raw, iso) {
    var rule = PHONE[iso] || PHONE.US;
    var s = String(raw || '').trim();
    if (!s) return { error: 'empty' };
    var intl = /^(\+|00)/.test(s);
    var digits = s.replace(/\D/g, '');
    if (intl) {
      if (s.indexOf('00') === 0) digits = digits.slice(2);
      if (digits.indexOf(rule.dial) !== 0) return { error: 'country' };
      digits = digits.slice(rule.dial.length);
    } else if (rule.dial === '1' && digits.length === 11 && digits.charAt(0) === '1') {
      digits = digits.slice(1);
    }
    if (rule.strip0 && digits.charAt(0) === '0') digits = digits.slice(1);
    if (!rule.test.test(digits)) return { error: 'invalid' };
    return { e164: '+' + rule.dial + digits };
  }

  function init(root) {
    if (!root || root.eaReady) return;
    var form = $('form', root);
    if (!form) return;
    root.eaReady = true;

    var mode = root.getAttribute('data-ea-mode') === 'endpoint' ? 'endpoint' : 'email';
    var endpoint = root.getAttribute('data-ea-endpoint') || '';
    var doubleOptIn = root.getAttribute('data-ea-dbl') === '1';
    var body = $('[data-ea-body]', root), done = $('[data-ea-done]', root);
    var first = $('[data-ea-first]', root), email = $('[data-ea-email]', root);
    var chEmail = $('[data-ea-ch="email"]', root), chSms = $('[data-ea-ch="sms"]', root);
    var smsTile = $('[data-ea-sms]', root), phoneBox = $('[data-ea-phone]', root);
    var cc = $('[data-ea-cc]', root), tel = $('[data-ea-tel]', root), hp = $('[data-ea-hp]', root);
    var btn = $('[data-ea-submit]', root), label = $('[data-ea-label]', root);
    var alertBox = $('[data-ea-alert]', root), alertText = $('[data-ea-alert-text]', root);
    var live = $('[data-ea-live]', root);
    var picksBox = $('[data-ea-picks]', root), addBtn = $('[data-ea-add]', root);
    var looks = Array.prototype.slice.call(root.querySelectorAll('[data-ea-look]'));
    var copy = {};
    var tpl = $('template[data-ea-copy]', root);
    if (tpl) Array.prototype.forEach.call(tpl.content.querySelectorAll('[data-k]'), function (n) { copy[n.getAttribute('data-k')] = n.textContent.trim(); });
    var idleLabel = label ? label.textContent : '';
    var busy = false, touched = {};

    /* With script the page checks fields itself and explains each problem in words. */
    form.noValidate = true;
    if (chEmail) chEmail.removeAttribute('required');

    /* The text-message choice exists only when a server can save its consent. */
    if (mode === 'endpoint' && smsTile) smsTile.hidden = false;
    else if (chSms) chSms = null;

    /* Arriving back from a sign-up Shopify finished without script. */
    if (done && !done.hidden) { clearDraft(); return; }

    /* Bring back what was typed if the page reloaded before the sign-up finished. */
    var draft = readDraft();
    if (draft) {
      if (first && !first.value && draft.first) first.value = draft.first;
      if (email && !email.value && draft.email) email.value = draft.email;
      if (tel && !tel.value && draft.tel) tel.value = draft.tel;
      if (cc && draft.cc && PHONE[draft.cc]) cc.value = draft.cc;
    }
    var saveTimer = 0;
    function saveDraft() {
      W.clearTimeout(saveTimer);
      saveTimer = W.setTimeout(function () {
        writeDraft({ first: first ? first.value : '', email: email ? email.value : '', tel: tel ? tel.value : '', cc: cc ? cc.value : '' });
      }, 250);
    }

    function errEl(k) { return $('[data-ea-err="' + k + '"]', root); }
    function setErr(k, input, msg) {
      var el = errEl(k);
      if (el) { el.textContent = msg || ''; el.hidden = !msg; }
      if (input) { if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
      return !msg;
    }
    function say(msg) { if (live) { live.textContent = ''; W.setTimeout(function () { live.textContent = msg; }, 30); } }
    function showAlert(msg) { if (!alertBox) return; alertText.textContent = msg; alertBox.hidden = !msg; }

    function wantsEmail() { return !!(chEmail && chEmail.checked); }
    function wantsSms() { return !!(chSms && chSms.checked); }

    function checkFirst() {
      var v = first ? first.value.trim() : '';
      return setErr('first', first, v.length > 60 ? 'Keep your first name under 60 characters.' : '');
    }
    function checkEmail(final) {
      if (!email) return true;
      var v = email.value.trim(), need = mode === 'email' || wantsEmail();
      if (!v) return setErr('email', email, need && final ? 'Enter your email address.' : '');
      if (!EMAIL_RE.test(v) || v.length > 254) return setErr('email', email, copy.err_email || 'Enter an email address like name@example.com.');
      return setErr('email', email, '');
    }
    function checkChannels() {
      var tiles = root.querySelectorAll('.ea-opt-tile'), ok = wantsEmail() || wantsSms(), msg = '';
      if (!ok) msg = mode === 'email' ? 'Check the box to get early-access updates by email.' : 'Choose email, text messages, or both.';
      Array.prototype.forEach.call(tiles, function (t) { t.classList.toggle('is-bad', !ok); });
      return setErr('channels', null, msg);
    }
    function checkTel(final) {
      if (!tel || !wantsSms()) { if (tel) setErr('tel', tel, ''); return true; }
      var r = parsePhone(tel.value, cc ? cc.value : 'US');
      if (r.error === 'empty') return setErr('tel', tel, final ? 'Enter your mobile number to get text updates.' : '');
      if (r.error === 'country') return setErr('tel', tel, 'This number starts with a different country code. Choose that country from the list, or enter the number without it.');
      if (r.error) return setErr('tel', tel, 'Enter a valid mobile number for the country code you chose.');
      return setErr('tel', tel, '');
    }

    function syncSms() {
      if (!chSms || !phoneBox) return;
      var on = chSms.checked;
      phoneBox.hidden = !on;
      chSms.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (!on) setErr('tel', tel, '');
    }

    /* Check as people go: once a field has been left, and again while they fix it. */
    [[first, 'first', checkFirst], [email, 'email', checkEmail], [tel, 'tel', checkTel]].forEach(function (f) {
      var el = f[0]; if (!el) return;
      el.addEventListener('blur', function () { if (el.value.trim()) touched[f[1]] = true; if (touched[f[1]]) f[2](false); });
      el.addEventListener('input', function () { saveDraft(); if (el.getAttribute('aria-invalid') === 'true') f[2](false); if (alertBox && !alertBox.hidden) showAlert(''); });
    });
    if (cc) cc.addEventListener('change', function () { saveDraft(); if (tel && tel.value.trim()) checkTel(false); });
    [chEmail, chSms].forEach(function (c) {
      if (!c) return;
      c.addEventListener('change', function () {
        syncSms();
        if (errEl('channels') && !errEl('channels').hidden) checkChannels();
        if (email && email.getAttribute('aria-invalid') === 'true') checkEmail(false);
        if (c === chSms && c.checked && tel) W.setTimeout(function () { tel.focus(); }, 0);
      });
    });
    syncSms();

    /* ------------------------------------------------------------ picks: color, size and quantity per look */
    if (picksBox) picksBox.hidden = false;
    function lookOn(look) { return look && !look.hidden && !look.disabled; }
    function pickOf(look, kind) { var c = look.querySelector('input[name^="hart_ea_' + kind + '_"]:checked'); return c ? c.value : ''; }
    function clampQty(input) {
      var max = parseInt(input.getAttribute('max'), 10) || 5, v = parseInt(input.value, 10);
      if (!(v >= 1)) v = 1;
      if (v > max) v = max;
      input.value = v;
      return v;
    }
    function checkSize(look) {
      var n = look.getAttribute('data-ea-look'), grp = look.querySelector('[data-ea-size-group]');
      var ok = !lookOn(look) || !!pickOf(look, 'size');
      if (grp) grp.classList.toggle('is-bad', !ok);
      return setErr('size' + n, null, ok ? '' : 'Choose a size for ' + (look.getAttribute('data-label') || 'this look').toLowerCase() + '.');
    }
    function showLook(img, url, alt) {
      if (!img || !url || img.getAttribute('src') === url) { if (img) img.alt = alt; return; }
      img.alt = alt;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { img.src = url; return; }
      img.classList.add('is-swap');
      var next = new Image();
      next.onload = next.onerror = function () { img.src = url; img.classList.remove('is-swap'); };
      next.src = url;
    }
    looks.forEach(function (look) {
      look.addEventListener('change', function (e) {
        var t = e.target;
        if (t.name && t.name.indexOf('hart_ea_color_') === 0) {
          var nm = $('[data-ea-color-name]', look); if (nm) nm.textContent = t.value;
          var img = $('[data-ea-look-img]', look);
          if (img) showLook(img, t.getAttribute('data-img'), (img.getAttribute('data-piece') || '') + ' in ' + t.value + (/design mockup/.test(img.alt) ? ' (design mockup)' : ''));
        }
        if (t.name && t.name.indexOf('hart_ea_size_') === 0) checkSize(look);
        if (t.matches('[data-ea-qty]')) clampQty(t);
      });
      look.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ea-step]');
        if (b) {
          var q = $('[data-ea-qty]', look);
          q.value = (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-ea-step'), 10);
          clampQty(q);
          say('Quantity ' + q.value);
          return;
        }
        if (e.target.closest('[data-ea-remove]')) {
          look.hidden = true; look.disabled = true;
          Array.prototype.forEach.call(look.querySelectorAll('input[type="radio"][name^="hart_ea_size_"]'), function (r) { r.checked = false; });
          setErr('size' + look.getAttribute('data-ea-look'), null, '');
          if (addBtn) { addBtn.hidden = false; addBtn.setAttribute('aria-expanded', 'false'); addBtn.focus(); }
        }
      });
      var q = $('[data-ea-qty]', look);
      if (q) q.addEventListener('blur', function () { clampQty(q); });
    });
    if (addBtn) addBtn.addEventListener('click', function () {
      var look = looks[1]; if (!look) return;
      look.hidden = false; look.disabled = false;
      addBtn.hidden = true; addBtn.setAttribute('aria-expanded', 'true');
      var first = look.querySelector('input[name^="hart_ea_color_"]:checked') || look.querySelector('input');
      if (first) first.focus();
    });
    function collectPicks() {
      return looks.filter(lookOn).map(function (look) {
        var img = $('[data-ea-look-img]', look);
        return {
          look: look.getAttribute('data-label') || '',
          piece: img ? img.getAttribute('data-piece') || '' : '',
          color: pickOf(look, 'color'),
          size: pickOf(look, 'size'),
          qty: clampQty($('[data-ea-qty]', look))
        };
      });
    }
    function pickWords(p) { return p.color + ', ' + p.size + ' × ' + p.qty; }
    function pickTag(p, i) {
      var clean = function (v) { return String(v || '').replace(/,/g, ' ').replace(/\s+/g, ' ').trim(); };
      return 'EA pick: ' + [clean(p.piece), clean(p.color), clean(p.size), 'Qty ' + p.qty].filter(Boolean).join(' / ') + (i ? ' / ' + clean(p.look) : '');
    }

    function setBusy(on) {
      busy = on;
      btn.disabled = on;
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (label) label.textContent = on ? (copy.busy || 'Reserving your spot…') : idleLabel;
    }

    function finish(kind, channels, picks) {
      var title = $('[data-ea-done-title]', root), text = $('[data-ea-done-text]', root), to = $('[data-ea-done-to]', root);
      var pk = $('[data-ea-done-picks]', root);
      if (pk) { pk.textContent = picks && picks.length ? 'Your picks: ' + picks.map(pickWords).join('   ·   ') : ''; pk.hidden = !(picks && picks.length); }
      var key = kind === 'already' ? 'already' : kind === 'pending' ? 'pending' : 'done';
      if (title) title.textContent = copy[key + '_title'] || title.textContent;
      if (text) text.textContent = copy[key + '_text'] || text.textContent;
      if (to) {
        var parts = [];
        if (channels.email) parts.push('Email: ' + channels.email);
        if (channels.sms) parts.push('Text: ' + channels.sms);
        to.textContent = parts.join('   ·   ');
        to.hidden = !parts.length;
      }
      clearDraft();
      done.style.minHeight = Math.min(body.offsetHeight, 560) + 'px';   // the card stays close to its size: little jump on the page
      body.hidden = true;
      done.hidden = false;
      done.focus({ preventScroll: true });
      var r = done.getBoundingClientRect();
      if (r.top < 80 || r.top > (W.innerHeight || 800) - 120) {
        try { root.querySelector('.ea__card').scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); } catch (e) {}
      }
      say((title ? title.textContent : '') + ' ' + (text ? text.textContent : ''));
    }

    function failed(msg) {
      setBusy(false);
      showAlert(msg || copy.err_server);
      say(msg || copy.err_server);
    }

    function withTimeout(promise, ctrl) {
      var t = W.setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT);
      return promise.then(function (v) { W.clearTimeout(t); return v; }, function (e) { W.clearTimeout(t); throw e; });
    }

    /* Email mode: send Shopify's own form and read Shopify's answer. Success is the redirect Shopify makes only
       after the customer is saved (?customer_posted=true). Anything else is not treated as saved. */
    function sendShopify(picks) {
      var data = new FormData(form), drop = [];
      data.forEach(function (v, k) { if (k.indexOf('hart_ea_') === 0) drop.push(k); });
      drop.forEach(function (k) { data.delete(k); });
      var tags = String(data.get('contact[tags]') || '').split(',').filter(Boolean);
      (picks || []).forEach(function (p, i) { tags.push(pickTag(p, i)); });
      data.set('contact[tags]', tags.join(','));
      var ctrl = W.AbortController ? new AbortController() : null;
      return withTimeout(fetch(form.getAttribute('action') || '/contact', {
        method: 'POST', body: new URLSearchParams(data), credentials: 'same-origin', redirect: 'follow',   // sent like a normal form post
        headers: { Accept: 'text/html' }, signal: ctrl ? ctrl.signal : undefined
      }), ctrl).then(function (res) {
        var url = res.url || '';
        if (/\/challenge(\b|\/|\?|$)/.test(url)) return { kind: 'challenge' };
        if (/[?&]customer_posted=true/.test(url)) return { kind: doubleOptIn ? 'pending' : 'done' };
        if (!res.ok) return { kind: 'fail' };
        return res.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var f = doc.getElementById(form.id), err = f && f.querySelector('[data-ea-server-error]');
          var msg = err ? err.textContent.trim() : '';
          if (msg) return /taken|already/i.test(msg) ? { kind: 'already' } : /email/i.test(msg) ? { kind: 'email' } : { kind: 'fail' };
          if (f && f.querySelector('[data-ea-done]:not([hidden])')) return { kind: doubleOptIn ? 'pending' : 'done' };
          return { kind: 'fail' };
        });
      });
    }

    /* Endpoint mode: one JSON request to HART's own server, which holds the private keys. */
    function sendEndpoint(payload) {
      var ctrl = W.AbortController ? new AbortController() : null;
      return withTimeout(fetch(endpoint, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined
      }), ctrl).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) {
          if (res.ok && j && j.ok) return { kind: j.status === 'already' ? 'already' : j.status === 'pending' ? 'pending' : 'done' };
          if (j && j.errors) return { kind: 'fields', errors: j.errors };
          return { kind: 'fail' };
        });
      });
    }

    form.addEventListener('submit', function (e) {
      if (form.eaNative) return;               // the fallback below: let the browser post it
      e.preventDefault();
      if (busy) return;                        // one request at a time; a second tap does nothing
      showAlert('');

      var okSizes = looks.map(checkSize).every(Boolean);
      var okFirst = checkFirst(), okCh = checkChannels(), okEmail = checkEmail(true), okTel = checkTel(true);
      if (!(okSizes && okFirst && okCh && okEmail && okTel)) {
        var badLook = looks.filter(function (l) { return lookOn(l) && !pickOf(l, 'size'); })[0];
        var bad = (badLook && badLook.querySelector('input[name^="hart_ea_size_"]')) || root.querySelector('[aria-invalid="true"]') || (!okCh ? (chEmail || chSms) : null);
        if (bad) bad.focus();
        say('Some details need a look before your spot can be saved.');
        return;
      }
      if (hp && hp.value) { failed(copy.err_server); return; }   // filled by a bot, not a person

      var phone = wantsSms() ? parsePhone(tel.value, cc.value).e164 : '';
      var channels = { email: wantsEmail() ? email.value.trim() : '', sms: phone };
      var picks = collectPicks();
      setBusy(true);

      var job;
      if (mode === 'endpoint') {
        job = sendEndpoint({
          firstName: first ? first.value.trim() : '',
          email: email ? email.value.trim() : '',
          emailConsent: wantsEmail(),
          phone: phone,
          phoneCountry: wantsSms() ? cc.value : '',
          smsConsent: wantsSms(),
          consentText: { email: wantsEmail() ? copy.email_consent : '', sms: wantsSms() ? copy.sms_consent : '' },
          picks: picks,
          source: 'HART Early Access',
          page: W.location.href,
          website: hp ? hp.value : ''
        });
      } else {
        job = sendShopify(picks);
      }

      job.then(function (r) {
        if (r.kind === 'done' || r.kind === 'pending' || r.kind === 'already') { setBusy(false); finish(r.kind, channels, picks); return; }
        if (r.kind === 'challenge') {           // Shopify wants a quick human check: post the form normally
          writeDraft({ first: first ? first.value : '', email: email ? email.value : '', tel: tel ? tel.value : '', cc: cc ? cc.value : '' });
          form.eaNative = true;
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        if (r.kind === 'email') { setBusy(false); setErr('email', email, copy.err_email); email.focus(); say(copy.err_email); return; }
        if (r.kind === 'fields') {
          setBusy(false);
          if (r.errors.email) setErr('email', email, String(r.errors.email));
          if (r.errors.phone && tel) setErr('tel', tel, String(r.errors.phone));
          var b = root.querySelector('[aria-invalid="true"]'); if (b) b.focus();
          showAlert(copy.err_server);
          return;
        }
        failed(copy.err_server);
      }).catch(function () { failed(copy.err_network); });
    });
  }

  function boot(scope) { Array.prototype.forEach.call((scope || D).querySelectorAll('[data-ea]'), init); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  D.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  W.HART_EA = { parsePhone: parsePhone };
})();
